import React from 'react'
import * as S from './Styles'
import brain from '../../Assets/img/brain.webp'
import smile from '../../Assets/img/smile.webp'
import chart from '../../Assets/img/chart.webp'
import shield from '../../Assets/img/shield.webp'
import saudemental1 from '../../Assets/img/saudemental1.webp'
import saudemental2 from '../../Assets/img/saudemental2.svg'
import saudemental3 from '../../Assets/img/saudemental3.webp'

export const SaudeMental = () => {
    return (
        <S.main id="saudeMental">
            <div className="firstContainer">
                <S.TitleDiv>
                    <p>POR QUE CUIDAR?</p>

                    <h3>Saúde Mental com Cuidado e Atenção</h3>
                </S.TitleDiv>

                <S.descDiv>
                    <p>O acompanhamento médico é fundamental para promover o equilíbrio emocional e melhorar sua qualidade de vida. Com o suporte adequado, você pode desenvolver recursos para enfrentar desafios, fortalecer sua saúde mental e alcançar seus objetivos pessoais.</p>
                </S.descDiv>

                <S.cardContainer>
                    <S.card>
                        <span>
                            <img src={brain} alt="Icone de cerebro" loading="lazy" />
                            <h3>Equilíbrio Mental</h3>
                        </span>

                        <p>Desenvolvimento de estratégias para lidar com desafios emocionais e manter a estabilidade mental.</p>
                    </S.card>

                    <S.card>
                        <span>
                            <img src={smile} alt="Icone de sorisso" loading="lazy"/>
                            <h3>Qualidade de Vida</h3>
                        </span>

                        <p>Melhora significativa no bem-estar geral, relacionamentos e satisfação pessoal.</p>
                    </S.card>

                    <S.card>
                        <span>
                            <img src={chart} alt="Icone de gráfico" loading="lazy"/>
                            <h3>Desenvolvimento Pessoal</h3>
                        </span>

                        <p>Crescimento contínuo através do autoconhecimento e fortalecimento emocional.</p>
                    </S.card>

                    <S.card>
                        <span>
                            <img src={shield} alt="Icone de escudo" loading="lazy"/>
                            <h3>Cuidado Preventivo</h3>
                        </span>

                        <p>Prevenção de crises e promoção de hábitos saudáveis para a saúde mental.</p>
                    </S.card>
                </S.cardContainer>
            </div>

            <div className="secondContainer">
                <S.imagesDiv>
                    <img src={saudemental1} alt="Imagem ilustrativa de saude mental" className='saudeMental1' loading="lazy"/>
                    <img src={saudemental2} alt="Imagem ilustrativa de consultorio" className='saudeMental2' loading="lazy"/>
                    <img src={saudemental3} alt="Imagem ilustrativa de meditação" className='saudeMental3' loading="lazy"/>

                    <span>
                        <h2>1000+</h2>
                        <p>Pacientes atendidos com dedicação e cuidado</p>
                    </span>
                </S.imagesDiv>
            </div>
        </S.main>
    )
}
